import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-weekly-account',
  templateUrl: './weekly-account.component.html',
  styleUrls: ['./weekly-account.component.scss']
})
export class WeeklyAccountComponent implements OnInit {

  public filterMonth:any;
  public weeks:any = [];
  public months:any = [];
  public is_mario:boolean = false;
  public other_profit:any;
  public todays:any = {}
  public today_date:any;
  public summary_checked:boolean = false;
  public permission:any = {};
  public configuration:any = {}
  constructor(private http: HttpService, private cdr: ChangeDetectorRef) { 
    this.getConfiguration();
    let today = new Date();
    let lm = (new Date());
    lm.setMonth(today.getMonth() - 1)
    this.filterMonth = today.getFullYear() + "-" + ("0" + (today.getMonth() + 1)).slice(-2);

    this.months = [{
        value: today.getFullYear() + "-" + ("0" + (today.getMonth() + 1)).slice(-2),
        label: ("0" + (today.getMonth() + 1)).slice(-2) + "-" + today.getFullYear()
      },
      {
        value: lm.getFullYear() + "-" + ("0" + (lm.getMonth() + 1)).slice(-2),
        label: ("0" + (lm.getMonth() + 1)).slice(-2) + "-" + lm.getFullYear()
      }
    ]


    today.setHours(0,0,0,0)
    this.today_date = today;

    this.http.getSelectedCompany().subscribe((v) => {

      if(v) {
        
        this.permission = this.http.getSelecetdCompanyDetail();

        let access:any = this.http.getAccess();

        if(access.is_mario) {
          this.is_mario = access.is_mario == "1" ? true : false;
        }

        this.monthChange(this.filterMonth);

      }
    });    

  }

  ngOnInit(): void {
  }
  public async getConfiguration() {
    let rtn:any = await this.http.post("/admin/company/setting");
    this.configuration = rtn.setting;
  }
  async monthChange(dt:any) {

    let month = this.filterMonth;
    this.weeks = []
    if(dt instanceof Event) {
      month = (dt.target as any).value;
    }

    this.summary_checked = false;
    let y:any = await this.http.post("/admin/weekly-account/get", {period: month});
console.log(y);
    this.weeks = y.data;
    this.summary_checked = y.summary_checked;

    this.other_profit = y.other_profit;

    this.cdr.detectChanges();
  }

  sum(key, arr) {
    let val = arr.map((v:any) => {
      return v[key] ?? 0
    })

    return val.reduce((partialSum, a) => parseFloat(partialSum) + parseFloat(a), 0);
  }

  updateBalance(day:any) {
    day.balance = parseFloat(day.debit ?? 0) - parseFloat(day.credit ?? 0) + parseFloat(day.adj_in ?? 0) - parseFloat(day.adj_out ?? 0) 
  }
 
  async save() {
    await this.http.post("/admin/weekly-account/save", {period: this.filterMonth, data: this.weeks, other_profit: this.other_profit})
  }

  flattern(weeks) {
    return weeks.flat();
  }

  isFutureDate(date:string) {
    let sd = (new Date(date)).setHours(0,0,0,0)
    return this.today_date <= sd
  }

}
